import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { setHeadersForFetch } from '../../objects/CommonUse/set_headers_for_fetch';
import { buildUrl } from '../../objects/CommonUse/build_URL';
import Config from '../../config';
import getCurrentDateTime from '../../objects/CommonUse/get_current_date_time';
import DropDownOptionCard from '../shared-components/drop_down_option_card';
import WaitTimeSpinner from '../shared-components/wait_time_spinner';
import editChangeAccountInformation from './objects/edit_change_account_information';
import determineAccountNbr from '../../objects/CommonUse/determine_account_nbr';


class ChangeAccountInformation extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.state={
        rerender: false,
        waitState: false,
        updateStep: "initial",
        updateType: "",
        newClassName: "",
        newEmailAddress: "",
        nbrPlayers: "",
        newGradeLevel: "",
        newAccountNbr: "",
        headers: setHeadersForFetch(),
        environment: Config.dataURL.currentEnv,
    }    
    this.accountList = [];
    
}

initialization(){
    this.message = "";
    this.messageClass = "";
    this.updateTypeClass = "";
    this.newClassNameClass = "";
    this.newEmailAddressClass = "";
    this.gradeLevelClass = "";
    this.nbrPlayersClass = "";
    this.newAccountNbrClass = "";
    this.defaultAccountNbr = sessionStorage.getItem("defaultUserAccount");
    this.defaultClassName = "";
    if (this.props.accountType === "Household"){
        this.handleUpdateTypeChange("accountProfile");
    }
    this.createAccountList();
    this.setState({rerender: !this.state.rerender})
}

createAccountList(){
    this.accountList = [];
    const initialObj = {value: "none", selection: "No Class Selected"};
    this.accountList.push(initialObj);
    const accountList = this.props.accountList;
    for (let i=0; i<accountList.length; i++){
        if (accountList[i].className !== "Demonstration class." && 
            accountList[i].accountNbr !== this.props.accountInfo.accountNbr){
            const listObj = {value: accountList[i].accountNbr, selection: accountList[i].className};
            this.accountList.push(listObj)
        }
        if (this.defaultAccountNbr === accountList[i].accountNbr){
            this.defaultClassName = accountList[i].className;
        }
    }
}

handleUpdateTypeChange(updateType){
    this.message = "";
    switch (updateType){
        case "accountProfile":
            this.heading = "Change Information for this " + this.props.accountType;
            break;
        case "createClass":
            this.heading = "Create a New " + this.props.accountType;
            break;
        case "changeDefault":
            this.heading = "Change the Default Class For this User";
            break;
        default:
            break;
    }
    this.setState({newClassName: ""});
    this.newEmailAddress = "";
    this.setState({updateType: updateType, updateStep: "initial"});
}

handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({
        [name]: value
    });
    this.startOver();
};


render() {
    let defaultClassOptions = [];

    if (this.state.updateType === "changeDefault"){
        defaultClassOptions = this.accountList.map((optionsList,index) =>
            <DropDownOptionCard options={optionsList} key={index} />
            );
    }
   
return <>
    <Modal className="text-center" show={this.props.show}  onHide={() => this.props.onClose()} 
       size="med" scrollable="true" animation={false}>
        <Modal.Header className="backgroundTopBottom" closeButton>
            <Modal.Title>Change Information for this {this.props.accountType} </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
              {this.state.waitState   ?
                <WaitTimeSpinner  />
              :
                null
              }
              <span>
                <div className="mx-3 my-4 font-weight-normal text-left">
                    <label className={this.updateTypeClass} htmlFor="updateType">Type of Change?:&nbsp;&nbsp;
                    </label>             
                    <select value={this.state.updateType || "none"}
                        onChange={(val) => this.handleUpdateTypeChange(val.target.value)}
                        className="btn btn-sm btn-outline-secondary dropdown-toggle" id="updateType">
                            <option value="none">No Change Type Selected</option>
                            <option value="accountProfile">
                                Change Basic Information for this {this.props.accountType}</option>
                            <option value="createClass" hidden={this.props.accountType === "Household"}>
                                Create a New Class
                            </option>
                            <option value="changeDefault" hidden={this.props.accountType === "Household" ||
                                this.accountList.length < 2 }>
                                Change Your Default Class
                            </option>
                    </select>
                </div>
                <h5 className="text-center my-2">{this.heading}</h5>
                {this.state.updateType === "accountProfile"  || this.state.updateType === "createClass"  ? 
                    <>
                        {this.props.accountType === "Class"  ?
                            <div className="mt-4 text-left ml-3">
                                <div><b>Current Class Name: </b> {this.props.accountInfo.className}&nbsp;
                                (Code: {this.props.accountInfo.accountNbr}) </div>
                                <label className={this.newClassNameClass} htmlFor="newClassName">
                                    New Class Name:&nbsp;&nbsp;</label>
                                <input type="text" className="input-med" id="newClassName" name="newClassName"
                                    onChange={this.handleChange}
                                    value={this.state.newClassName}></input> 
                            </div>
                        :
                            null
                        }
                        <div className="mt-4 text-left ml-3">
                            <div><b>Email Address: </b> {this.props.accountInfo.emailAddress}</div>
                            <label className={this.newEmailAddressClass} htmlFor="newEmailAddress">
                                New Email Address:&nbsp;&nbsp;</label>
                            <input type="text" className="input-med" id="newEmailAddress" name="newEmailAddress"
                                onChange={this.handleChange}
                                value={this.state.newEmailAddress}></input> 
                        </div>
                        {this.state.updateType === "createClass" ?
                        <>
                            <div className="mt-2 text-left ml-3">
                                <label className={this.nbrPlayersClass} htmlFor="nbrPlayers">
                                        Nbr of Player Ids: &nbsp;&nbsp;</label>
                                    <input
                                        className="col-small"
                                        type="text"
                                        name="nbrPlayers"
                                        value={this.state.nbrPlayers}
                                        onChange={this.handleChange}>
                                    </input>
                            </div> 
                            <div className="mt-2 text-left ml-3">
                                <label className={this.newGradeLevelClass} htmlFor="newGradeLevel">
                                    Player Grade Level:&nbsp;&nbsp;</label>
                                <select 
                                    className="btn btn-sm btn-outline-secondary dropdown-toggle" id="gradeLevel"
                                    value={this.state.newGradeLevel} name="newGradeLevel" 
                                    onChange={this.handleChange}>
                                        <option value="none">no grade level slctd</option>
                                        <option value="Elementary">Elementary School</option>
                                        <option value="MiddleSchool">Middle or Junior High School</option>
                                        <option value="HighSchool">High School</option>
                                </select>
                            </div>
                        </>
                        :
                            null
                        }
                    </>
                :
                    null
                }

                {this.state.updateType === "changeDefault" ?
                    <>
                        <div className="mt-4 text-left ml-3"><b>Current Default Class: </b>
                            {this.defaultClassName} ({this.defaultAccountNbr})
                        </div>
                        <div className="mt-2 text-left ml-3">
                            <label className={this.newAccountNbrClass} htmlFor="newAccountNbr">Default Class:&nbsp;&nbsp;
                            </label>             
                            <select value={this.state.newAccountNbr || "none"} name="newAccountNbr"
                                onChange={this.handleChange}
                                className="btn btn-sm btn-outline-secondary dropdown-toggle" id="newAccountNbr">
                                    {defaultClassOptions}
                            </select>
                        </div>
                    </>
                :
                    null
                }
            </span>
                    
        </Modal.Body>
        <Modal.Footer className="backgroundTopBottom p-0" >
              <div className={this.messageClass}>
                    {this.message}
              </div>
              <div>
                {this.state.updateStep === "initial"  ?
                    <>
                        <Button variant="primary"  onClick={() => this.processUserInput()}>
                            Submit
                        </Button>
                        <Button className="ml-4" variant="secondary"  onClick={() => this.props.onClose()}>
                            Close
                        </Button>
                    </>
                :
                    null
                }
                {this.state.updateStep === "confirm"  ?
                    <>
                        <Button variant="primary"  onClick={() => this.updateUserAndAccount()}>
                            Confirm
                        </Button>
                        <Button className="ml-4" variant="secondary"  onClick={() => this.startOver()}>
                            Reset/Clear
                        </Button>
                        <Button className="ml-4" variant="secondary"  onClick={() => this.props.onClose()}>
                            Close
                        </Button>
                    </>
                :
                    null
                }
                </div>

        </Modal.Footer>
       
    </Modal>
    
  </>
}

componentDidMount(){
    this.initialization();
}

processUserInput(){
    this.message = "";
    this.messageClass = "text-danger font-weight-bold text-left ml-4 w-100";
    const editObj = editChangeAccountInformation(this.state.updateType, this.state.newClassName, 
        this.state.newEmailAddress, this.state.newGradeLevel, this.state.nbrPlayers,
        this.state.newAccountNbr );
    this.message = editObj.message;
    this.newClassNameClass = editObj.newClassNameClass;
    this.newEmailAddressClass = editObj.newEmailAddressClass;
    this.newGradeLevelClass = editObj.newGradeLevelClass;
    this.nbrPlayersClass = editObj.nbrPlayersClass;
    this.newAccountNbrClass = editObj.newAccountNbrClass;
    if (editObj.errorsFound === false){
        this.messageClass="text-green font-weight-bold text-left ml-4 w-100";
        this.message="Entries are valid, click the 'Confirm' button to finish update.";
        let newClassName = this.state.newClassName;
        if (this.state.newClassName === ""){
            newClassName = this.props.accountInfo.className;
        }
        let newEmailAddress = this.state.newEmailAddress;
        if (this.state.newEmailAddress === ""){
            newEmailAddress = this.props.accountInfo.emailAddress;
        }
        this.setState({updateStep: "confirm", newClassName: newClassName, newEmailAddress: newEmailAddress});
    }else{
        this.setState({rerender: !this.state.rerender});
    }
}

startOver(){
    this.message = "";
    this.setState({updateStep:  "initial"});
}

updateUserAndAccount(){
    this.setState({waitstate: true});
    this.username = sessionStorage.getItem("username");
    this.userRole = sessionStorage.getItem("userRole");
    if (this.state.updateType === "accountProfile") {
        let newAccountData = JSON.parse(JSON.stringify(this.props.accountInfo));
        newAccountData.className = this.state.newClassName;
        newAccountData.emailAddress = this.state.newEmailAddress;
        this.props.updateAccount(newAccountData, this.state.updateType);
    }
    if (this.state.updateType === "createClass"){
        this.setState({waitState: true});
        //  getAccountList calls process to build the account record and the props update
        this.getAccountList();
    }
    if (this.state.updateType === "changeDefault"){
        const userObj = {username:this.username, accountNbr: this.state.newAccountNbr, role: this.userRole};
        this.props.updateUser(userObj);
    }
    this.setState({waitState: false});
}

buildAccountRecord(){
    const currentDateTime = getCurrentDateTime();
    const rqstdUsersArr = [{role: this.userRole, dateRqstd: currentDateTime.date, nbrUsersRqstd: 1},
        {role: "player", dateRqstd: currentDateTime.date, nbrUsersRqstd: this.state.nbrPlayers}];
    const newAccountRecord = {
        accountNbr: this.calcAccountNbr,
        accountOwner: this.username,
        accountOwnerArr: [{username: this.username, dateUpdated: currentDateTime.date}],
        className: this.state.newClassName,
        emailAddress: this.state.newEmailAddress,
        gradeLevel: this.state.newGradeLevel,
        rqstdUsersArr: rqstdUsersArr
    }
    this.setState({waitState: false});
    this.props.updateAccount(newAccountRecord, this.state.updateType);
}

getAccountList(){
    const funcName = "loadAccountList";
    const urlParm = "";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch(uri,
        {method:'GET',
        headers: this.state.headers,
        })
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        this.accountList = output.body;
                        this.calcAccountNbr = determineAccountNbr(this.accountList);
                        this.buildAccountRecord();
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message};
                        this.props.processError(errorObj);
                    }
                });
            };
        })
}

}
export default ChangeAccountInformation;